import styles from "./ButtonGroup.module.scss"

type Option = {
  label: string
  value: string | number
}

type ButtonGroupProps = {
  options: Option[]
  onClick: (value: Option["value"]) => void
  selectedValue?: Option["value"]
}

const ButtonGroup = ({ options, onClick, selectedValue }: ButtonGroupProps) => {
  const handleClick = (value: Option["value"]) => {
    onClick(value)
  }

  return (
    <div className={`btn-group ${styles.buttonGroup}`} role="group" aria-label="Button group">
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => handleClick(option.value)}
          className={`btn ${styles.button}`}
          style={{
            backgroundColor:
              selectedValue === option.value
                ? "light-dark(#6c757d, rgba(255, 255, 255, 0.05))"
                : "transparent",
            color:
              selectedValue === option.value
                ? "#ffffff"
                : "light-dark(#6c757d, rgba(255, 255, 255, 0.5))",
          }}
          onMouseEnter={(e) => {
            if (selectedValue !== option.value) {
              e.currentTarget.style.backgroundColor =
                "light-dark(#e9ecef, rgba(255, 255, 255, 0.05))"
            }
          }}
          onMouseLeave={(e) => {
            if (selectedValue !== option.value) {
              e.currentTarget.style.backgroundColor = "transparent"
            }
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default ButtonGroup
